import { type ValidateStatus } from "antd/es/form/FormItem";

export const validateJson = (
  value: string,
): {
  validateStatus: ValidateStatus;
  errorMsg: string | null;
} => {
  try {
    const jsonParsed = JSON.parse(value);
    console.log("json load diagnostics", jsonParsed);
    return {
      validateStatus: "success",
      errorMsg: null,
    };
  } catch (err) {
    return {
      validateStatus: "error",
      errorMsg: "Некорректный json",
    };
  }
};

export const objectToJson = (value: any): string => {
  return JSON.stringify(value, null, 2);
};
